<template>
  <div v-if="requirements">
    <h5 class="display-18 font-weight-medium">
      {{ title }}
    </h5>
    <v-layout  pa-0 class="display-18 pa-0">
      <p class="display-18 ma-0" v-html="requirements">
        
      </p>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    requirements: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: 'דרישות התפקיד',
      requirementsEmpty: true
    }
  },
}
</script>

<style lang="scss" scoped>
p {
  display: list-item;
  list-style: none;
  position: relative;
}

li span {
  color: $primary;
}

ul {
  list-style: none;
}
</style>
